import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Spinner } from "../components/common";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="bg-scene" />
      <div className="glass rounded-3xl p-8 w-full max-w-md anim-fade-up">
        <h1 className="font-display text-xl font-bold text-white mb-2">Recuperar senha</h1>
        {sent ? (
          <div data-testid="forgot-success-msg">
            <p className="text-sm text-slate-400 leading-relaxed">Se esse email estiver cadastrado, um link de redefinição foi enviado. Verifique sua caixa de entrada.</p>
            <Link data-testid="back-to-login-link" to="/login" className="mt-6 inline-block text-sm text-cyan-400 hover:text-cyan-300">← Voltar para o login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-4">
            <p className="text-sm text-slate-400">Informe seu email para receber o link de redefinição.</p>
            <input data-testid="forgot-email-input" type="email" className="input-dark w-full rounded-xl px-4 py-3 text-sm" placeholder="voce@email.com" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <button data-testid="forgot-submit-btn" disabled={loading} className="btn-neon w-full py-3.5 rounded-xl text-sm flex items-center justify-center gap-2">
              {loading ? <Spinner /> : "Enviar link de redefinição"}
            </button>
            <div className="text-center">
              <Link to="/login" className="text-xs text-slate-500 hover:text-slate-300">← Voltar para o login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
